// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"85df65830bf9094ee9f1","532":"d8b8f7ab15e6953809bd","691":"7c8d144cf9025687d77f"}[chunkId] + ".js";
};